module.exports = __webpack_public_path__ + "img/notionLogo.2750d177.svg";